import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';

export const StatusIndicator = ({ status }) => {
  switch (status) {
  case 'ACTIVE': {
    return (
      <div data-testid={`job-posting-status-${status}`} className="ptp-availability-text ptp-availability-text__available">
        <div className="ptp-job-posting__availible-icon" />
        <p>ACTIVE</p>
      </div>
    );
  }
  case 'DRAFT': {
    return (
      <div data-testid={`job-posting-status-${status}`} className="ptp-availability-text ptp-availability-text__job-posting-draft">
        <p>DRAFT</p>
      </div>
    );
  }
  case 'COMPLETED': {
    return (
      <div data-testid={`job-posting-status-${status}`} className="ptp-availability-text ptp-availability-text__complete">
        <CheckIcon />
        <p>COMPLETE</p>
      </div>
    );
  }
  case 'CANCELLED': {
    return (
      <div data-testid={`job-posting-status-${status}`} className="ptp-availability-text ptp-availability-text__cancelled">
        <p>CANCELLED</p>
      </div>
    );
  }
  default: {
    return null;
  }
  }
};

StatusIndicator.propTypes = {
  status: PropTypes.string
};

StatusIndicator.defaultProps = {
  status: undefined
};
